import styled from 'styled-components'
import tw from 'twin.macro'

export const NotificationSettingsWrapper = styled.div`
  ${tw`flex flex-col flex-shrink-0 items-start gap-2.5`}
  ${tw`w-full smd:w-5/6 h-auto smd:ml-12`}
  ${tw`p-9 py-7`}
  ${tw`rounded-3xl bg-white shadow-lg`}
`
